import team1 from '../Images/teamH.jpeg'
import team2 from '../Images/team0.jpeg'

const data = [
    {
        text: 'We aim to set the standard as Africa’s foremost independent producer of premium-quality lubricants, driving excellence and innovation in the industry.',
        header: 'Vision',
        img: team1
    },
    {
        text: 'At Oyoyo, our mission is to consistently enhance the quality of our products and services while boosting the productivity of the communities we serve. We prioritize environmental protection and are committed to making a positive impact on society.',
        header: 'Mission',
        img: team2
    },
]

export default data;